import { render } from "./APPDownloadHomePage.vue?vue&type=template&id=35d46b5f"
import script from "./APPDownloadHomePage.vue?vue&type=script&lang=js"
export * from "./APPDownloadHomePage.vue?vue&type=script&lang=js"

import "./APPDownloadHomePage.vue?vue&type=style&index=0&id=35d46b5f&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__